import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  por?: string | null;
  disciplina?: string | null;
  prancha?: string | null;
  revisao?: string | null;
};

type Actions = {
  setPor: (por: string | null) => void;

  setDisciplina: (disciplina: string | null) => void;
  setPrancha: (prancha: string | null) => void;
  setRevisao: (revisao: string | null) => void;

  clear: () => void;
};

export const useFiltersDisciplinasArquivos = create<State & Actions>((set) => ({
  por: null,

  disciplina: null,
  prancha: null,
  revisao: null,

  setPor: (por) => set({ por }),

  setDisciplina: (disciplina) => set({ disciplina }),
  setPrancha: (prancha) => set({ prancha }),
  setRevisao: (revisao) => set({ revisao }),

  clear: () =>
    set({
      por: null,
      disciplina: null,
      prancha: null,
      revisao: null,
    }),
}));
